// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-15FtF";
var _4 = "footer-1WFVK";
var _5 = "cardExtraButtonStatus-15E-0";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "footer", _5 as "cardExtraButtonStatus" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "footer": _4, "cardExtraButtonStatus": _5 }
